import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

export const TickerWrapper = styled.div`
  overflow: hidden;
  flex: 1;
  background: linear-gradient(
    90deg,
    #56f2f7 0%,
    #2670d1 33%,
    #7b44f2 66%,
    #ae4a96 100%
  );
  // background: #f4f4f4;
  white-space: nowrap;
  display: flex;
  padding: 5px 0;
  align-items: center;
  position: relative;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 50px;
    height: 100%;
    z-index: 2;
  }
  &::before {
    left: 0;
    background: linear-gradient(to right, white, transparent);
  }
  &::after {
    right: 0;
    background: linear-gradient(to left, white, transparent);
  }
`;

export const TickerMove = styled.div`
  display: inline-block;
  animation: ${scroll} 45s linear infinite;
  &:hover {
    animation-play-state: paused;
  }
`;

export const TickerItem = styled.span`
  display: inline-block;
  padding: 0 35px;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  strong {
    margin-right: 15px;
  }
`;
